<script lang="ts">
    import { link } from 'svelte-spa-router';
    export let icon: string = 'inbox';
    export let title: string;
    export let description: string = '';
    export let actionLabel: string = '';
    export let actionHref: string = '';
</script>

<div class="empty-state" role="status">
    <div class="empty-icon" aria-hidden="true">
        <i class="{icon} icon"></i>
    </div>
    <h2 class="empty-title">{title}</h2>
    {#if description}<p class="empty-description">{description}</p>{/if}
    {#if actionLabel && actionHref}
        <a use:link href={actionHref} class="empty-action">
            <span>{actionLabel}</span>
            <i class="arrow right icon" aria-hidden="true"></i>
        </a>
    {/if}
    <slot />
</div>

<style>
    .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: var(--space-10) var(--space-5);
        color: var(--grey-secondary);
        min-height: 320px;
    }

    .empty-icon :global(i.icon) {
        font-size: 3rem;
        color: var(--grey-secondary);
        opacity: .5;
        margin-bottom: var(--space-4);
    }

    .empty-title {
        font-size: var(--text-xl);
        font-weight: 500;
        color: var(--grey);
        margin: 0 0 var(--space-2) 0;
        text-wrap: balance;
    }

    .empty-description {
        font-size: var(--text-base);
        color: var(--grey-secondary);
        margin: 0 0 var(--space-5) 0;
        max-width: 420px;
        text-wrap: pretty;
    }

    .empty-action {
        display: inline-flex;
        align-items: center;
        gap: var(--space-2);
        padding: var(--space-3) var(--space-5);
        background: var(--primary);
        color: var(--white);
        border-radius: var(--radius-cta);
        text-decoration: none;
        font-weight: 500;
        box-shadow: var(--shadow-cta);
        transition: filter .15s;
    }

    .empty-action:hover { filter: brightness(.95); color: var(--white); }
    .empty-action:focus-visible { outline: none; box-shadow: var(--focus-ring); }
</style>
